import { Result, ok, err } from "neverthrow";
import { ParseError } from "../../shared/errors/parseError";
import {
  IQnaInfoDetailParser,
  HttpQnaInfoDetail,
  HttpFile,
  HttpTalkReply,
  HttpQnaInfoDetailParams,
  HttpQnaDetailDeletedFileParams,
  HttpQnaDetailFileParams,
} from "../bbsRepository.types";
import dayjs from "dayjs";
import { injectable } from "inversify";
import {
  IDeletedFile,
  IFile,
  IQnaDetail,
  ITalkReply,
} from "@/domain/entities/bbs/qnaDetail.types";
import { QnaInfoDetail } from "@/domain/entities/bbs/qnaDetail";
import { parseQnaInfo } from "./qnaInfosCollectionParser";

function praseFile(data: HttpFile): IFile {
  const file: IFile = {
    fileUid: data.fileUid,
    trxUid: data.trxUid,
    fileTypeCode: data.fileTypeCode,
    fileTypeName: data.fileTypeName,
    fileName: data.fileName,
    fileUrl: data.fileUrl,
    savedTs: data.savedTs,
  };
  return file;
}

function parseTalkReply(httpTalkReply: HttpTalkReply): ITalkReply {
  const talkReply: ITalkReply = {
    title: httpTalkReply.title,
    bodyText: httpTalkReply.bodyText,
    createdTs: dayjs(httpTalkReply.createdTs).format("YYYY-MM-DD HH:mm:ss"),
    savedTs: dayjs(httpTalkReply.savedTs).format("YYYY-MM-DD HH:mm:ss"),
  };

  return talkReply;
}

function parseDeletedFile(
  deletedFile: IDeletedFile
): HttpQnaDetailDeletedFileParams {
  const parsed: HttpQnaDetailDeletedFileParams = {
    fileUid: deletedFile.fileUid,
  };

  return parsed;
}

function parseFile(file: IFile): HttpQnaDetailFileParams {
  const parsed: HttpQnaDetailFileParams = file.fileUid
    ? { fileUid: file.fileUid }
    : { fileName: file.fileName };

  return parsed;
}

@injectable()
export class QnaInfoDetailParser implements IQnaInfoDetailParser {
  constructor() {}

  toDomain(data: HttpQnaInfoDetail): Result<IQnaDetail, ParseError> {
    try {
      const baseInfo = parseQnaInfo(data);
      const qnaInfoDetail: IQnaDetail = {
        ...baseInfo,
        updatedTs: data.updatedTs
          ? dayjs(data.updatedTs).format("YYYY-MM-DD HH:mm")
          : undefined,
        files: data.files ? data.files.map(praseFile) : [],
        talkReplies: data.talkReplies?.map(parseTalkReply),
      };

      return ok(new QnaInfoDetail(qnaInfoDetail));
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }

  fromDomain(data: IQnaDetail): HttpQnaInfoDetailParams {
    const parsed: HttpQnaInfoDetailParams = {
      talkTypeCode: data.talkTypeCode,
      talkBbsCode: data.talkBbsCode,
      title: data.title,
      bodyText: data.bodyText ?? "",
      qnaTypeCode: data.talkTypeCode,
      secretYn: data.secretYn,
      date: dayjs(data.savedTs).format("YYYY-MM-DD"),
      time: dayjs(data.savedTs).format("HH:mm"),
      files:
        data.files
          ?.map(parseFile)
          .filter((file) => !!file.fileName || !!file.fileUid) ?? [],
      deletedFiles: data.deletedFiles?.map(parseDeletedFile) ?? [],
    };
    return parsed;
  }
}
